import styled from 'styled-components';

export const CarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: 0 auto;

  max-width: 1250px;

  @media screen and (max-width: 1419px) and (min-width: 1025px) {
    max-width: 1120px;
  }

  @media screen and (max-width: 1024px) and (min-width: 601px) {
    max-width: 600px;
  }

  @media screen and (max-width: 600px) {
    max-width: 360px;
  }
`;

export const CarouselTrack = styled.div<{ translateX: number }>`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${props => props.translateX}px);
  width: fit-content;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  border-radius: 10px;
  transition: all ease-in-out 0.3s;
  flex-shrink: 0;
  box-sizing: border-box;

  width: 250px;

  @media screen and (max-width: 1419px) and (min-width: 1025px) {
    width: 280px;
  }

  @media screen and (max-width: 1024px) and (min-width: 601px) {
    width: 200px;
  }

  @media screen and (max-width: 600px) {
    width: 120px;
  }
`;

export const Logo = styled.img`
  max-width: calc(100% - 10px);
  max-height: calc(100% - 10px);
  width: auto;
  height: auto;
  object-fit: contain;
  transition: filter 0.3s ease;
  margin: 5px;

  @media screen and (max-width: 500px) {
    max-width: calc(100% - 6px);
    max-height: calc(100% - 6px);
    margin: 3px;
  }
`;
